import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import { importFile, addFileInImport, FileType, FileError } from '../../containers/ImportManager/actions';
import { Api } from '../../typings/api';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';

interface ImportManagerProps {
	id: string;
	triggerComponent: React.ReactNode;
	extensions?: string;
	isMultiple?: boolean;
	onImport?: (item: Api.DriveItem) => void;
	customImportHandler?: (files: File | File[], isCorrectFileTypes: boolean) => void;
	fileType?: FileType;
	isOptimizedImageImport?: boolean;
	isPublicationDependency?: boolean;
	dispatch: Dispatch<StoreState>;
}

const ImportManager = ({
	id,
	triggerComponent,
	extensions,
	isMultiple,
	onImport = () => undefined,
	customImportHandler,
	fileType,
	isOptimizedImageImport,
	isPublicationDependency,
	dispatch,
}: ImportManagerProps) => {
	const inputElement = React.useRef<HTMLInputElement>(null);

	const isCorrectFileType = (fileName: string, extensions?: string): boolean => {
		if (!extensions) {
			return true;
		}

		const fileExtension = `.${Utils.getFileExtension(fileName)}`;
		return extensions.includes(fileExtension.toLowerCase());
	};

	const handleChange = ({ target: { files } }: React.ChangeEvent<HTMLInputElement>) => {
		if (!files) {
			return;
		}

		const filesArray = Array.from(files);
		const validFiles = filesArray.filter(file => isCorrectFileType(file.name, extensions));
		const isCorrectFileTypes = filesArray.every(file => isCorrectFileType(file.name, extensions));

		if (customImportHandler) {
			customImportHandler(isMultiple ? validFiles : validFiles[0], isCorrectFileTypes);
		} else {
			if (isCorrectFileTypes) {
				filesArray.forEach(file => dispatch(importFile({
					id,
					file,
					onImport,
					fileType,
					isOptimizedImageImport,
					isPublicationDependency,
				})));
			} else {
				dispatch(addFileInImport(id, {
					id,
					percentage: 100,
					error: FileError.TYPE,
				}));
			}
		}

		if (inputElement.current) {
			inputElement.current.value = '';
		}
	};

	return (
		<>
			<input
				type="file"
				ref={inputElement}
				id={id}
				multiple={isMultiple}
				// on Android file dialog isn't opened if accept param is set
				accept={UserAgentUtils.isAndroidApp() ? undefined : extensions}
				hidden={true}
				onChange={handleChange}
			/>
			<label htmlFor={id}>{triggerComponent}</label>
		</>
	);
};

export default ImportManager;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportManager/index.tsx